export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12131.a9d080c7.jpg";